import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({

    header:{        
            ['@media (max-width : 460px)']:{
                top: '-1%',        
            },
    },
    subtitle:{          
        borderBottom: `1px solid #ccc!important`,
        backgroundColor: "white",
        color:'black',
        fontWeight: 600,
        fontFamily: 'sans-serif',
        letterSpacing: '0.1px',
        textAlign: 'center',
        transition: '0.4s ease-out',
        ['@media (max-width: 2000px)'] :{  //web
            padding: "2% 4% 1% 7%",          
            fontSize: "1.5rem",            
        },
        ['@media (max-width:1566px)']:{ // web
            padding: "2% 0% 0% 2%",
        },
        ['@media (max-width:1024px)']:{ // web
            padding: "2% 0% 0% 3%",
        },
        ['@media (max-width:768px)']:{ //ipad
        },
        ['@media (max-width:460px)']:{ //mobile
            paddingTop: "4%",
            color:"#fff",
            fontSize: "1rem",
            textShadow: '0px 0px 0px',
        }
    },
    description:{          
        // fontFamily: 'none',
        letterSpacing: '0.1px',
        transition: '0.4s ease-out',
        color: 'black',
        textAlign: 'center',
        ['@media (max-width: 2000px)'] :{  //web
            fontSize: "1.5rem",            
        },
        ['@media (max-width:1566px)']:{ // web
            fontSize: "1.3rem",
        },
        ['@media (max-width:1024px)']:{ // web
            fontSize: "0.8rem",
        },
        ['@media (max-width:768px)']:{ //ipad
            fontSize: "0.6rem",
        },
        ['@media (max-width:460px)']:{ //mobile
            paddingTop: "4%",
            fontSize: "0.5rem",
            textShadow: '0px 0px 0px',
        }
    },
}));

